import banner from "../../../courses/module-2/img4.png";

const modulo4 = {
  courseId: "cripto-blockchain",
  id: "modulo-4",
  title: "🧩 MODULE 4: Stablecoins, Tokens and the Real World of Crypto",
  estimatedDuration: "1 hour",
  format: "Reading + knowledge check activity",
  bannerUrl: banner,
  sections: [
    {
      id: "objetivos",
      navLabel: "Objectives",
      title: "🎯 What will you learn in this module?",
      content: [
        "What a stablecoin is and why they are key in the Web3 ecosystem.",
        "How tokens and native coins are different.",
        "The real role of USDT, USDC, DAI and XLM.",
        "Real use cases in trading, payments, remittances and saving.",
        "How to avoid common mistakes when transferring between different networks.",
      ],
    },
    {
      id: "conceptos-clave",
      navLabel: "Key concepts",
      title: "📚 Key concepts",
      content: [
        {
          type: "paragraph",
          text: "🟡 What is a stablecoin?",
        },
        {
          type: "paragraph",
          text: "A stablecoin is a cryptocurrency designed to keep a stable value. Its price is usually “pegged” to a traditional currency, such as the dollar or the euro. Stablecoins are used as a bridge between the crypto world and traditional money.",
        },
        {
          type: "paragraph",
          text: "Popular examples:",
        },
        {
          type: "list",
          items: [
            "USDT (Tether): The most widely used stablecoin, but it has received criticism for its lack of transparency.",
            "USDC (USD Coin): Issued by Circle and backed 100% by dollar reserves.",
            "DAI: A decentralized stablecoin created by the MakerDAO protocol. It does not depend on banks, but on collateral in other cryptocurrencies.",
          ],
        },
        {
          type: "paragraph",
          text: "🧾 What is a token?",
        },
        {
          type: "paragraph",
          text: "A token is a digital asset built on top of an existing blockchain. For example, USDT is a token that can exist on the Ethereum network, the Tron network, Polygon, and more.",
        },
        {
          type: "paragraph",
          text: "🔗 And what is a native coin?",
        },
        {
          type: "paragraph",
          text: "It is the cryptocurrency that belongs natively to a blockchain network. For example:",
        },
        {
          type: "list",
          items: [
            "BTC is the native coin of Bitcoin.",
            "ETH is the native coin of Ethereum.",
            "XLM is the native coin of Stellar.",
          ],
        },
        {
          type: "paragraph",
          text: "These coins are usually needed to pay transaction fees, also known as fees or gas, within their respective networks.",
        },
      ],
    },
    {
      id: "nota",
      navLabel: "Important note",
      title:
        "⚠️ IMPORTANT NOTE – Do not confuse the network with the cryptocurrency",
      content: [
        {
          type: "paragraph",
          text: "Sometimes, the same cryptocurrency, such as USDT or USDC, can exist on different networks: Ethereum, Polygon, Solana, and others.",
        },
        {
          type: "paragraph",
          text: "If you send it through the wrong network, you can lose it forever.",
        },
        {
          type: "paragraph",
          text: "✅ Always verify:",
        },
        {
          type: "list",
          items: [
            "The correct network before sending or receiving.",
            "That the other person or platform accepts that network.",
            "That the token is compatible with the selected network.",
          ],
        },
        {
          type: "paragraph",
          text: "🧠 In Web3, you are the only person responsible for your funds. Never make transfers unless you are 100% sure.",
        },
      ],
    },
    {
      id: "ejemplos-reales",
      navLabel: "Examples",
      title: "🌐 Real-world examples",
      content: [
        {
          type: "list",
          items: [
            "USDC on Stellar: used by NGOs to distribute humanitarian aid in conflict zones, with low cost and without the need for banks.",
            "USDT on Binance and KuCoin: used as a base currency to buy and sell other cryptocurrencies.",
            "DAI in DeFi: used to get loans and generate interest without going through banks.",
            "XLM on MoneyGram: used for fast and low-cost remittances in Latin America.",
          ],
        },
      ],
    },
    {
      id: "recursos",
      navLabel: "Resources",
      title: "📌 Recommended resources",
      content: [
        {
          type: "link",
          href: "https://academy.binance.com/es/articles/what-is-a-stablecoin",
          text: "Binance Academy – What is a stablecoin?",
        },
        {
          type: "link",
          href: "https://www.coinbase.com/es-ar/usdc",
          text: "Coinbase Learn – What is USDC?",
        },
        {
          type: "link",
          href: "https://academy.binance.com/en/glossary/coin",
          text: "Binance Academy – Tokens vs Coins",
        },
      ],
    },
    {
      id: "actividad",
      navLabel: "Activity",
      title: "📝 Activity: comparison table + reflection",
      content: [
        {
          type: "paragraph",
          text: "🔧 Step-by-step instructions",
        },
        {
          type: "orderedList",
          items: [
            "Go to docs.google.com and create a new document.",
            "Insert a table with 6 columns and 5 rows.",
            "Copy the model below and complete it with the information you learned:",
          ],
        },
        {
          type: "table",
          headers: [
            "Name",
            "Type (coin or stablecoin)",
            "Who issues it?",
            "Main network?",
            "What is it used for?",
            "Risk level",
          ],
          rows: [
            ["USDT", "", "", "", "", ""],
            ["USDC", "", "", "", "", ""],
            ["DAI", "", "", "", "", ""],
            ["XLM", "", "", "", "", ""],
          ],
        },
        {
          type: "paragraph",
          text: "4. Add a conclusion:",
        },
        {
          type: "paragraph",
          text: "Which one seems more useful or safer for a beginner? Why?",
        },
      ],
    },
    {
      id: "frase",
      navLabel: "Quote",
      title: "🧠 Quote of the day",
      content: [
        "“Understanding the real value of a coin is more important than knowing how much it costs.”",
      ],
    },
  ],
};

export default modulo4;
